import request from '@/utils/request'
import da from "element-ui/src/locale/lang/da";
//获取出金记录列表
export function getWithdrawal(params) {
  return request({
    url:'/admin/withdrawal',
    method:'get',
    params:params
  })
}
//出金审核通过
export function passReview(data) {
  return request({
    url:'/admin/withdrawal/pass/'+data,
    method:'put',
  })
}
//出金不通过
export function failReview(data) {
  return request({
    url:'/admin/withdrawal/fail',
    method:'put',
    data:data
  })
}
//出金放行
export function withdrawalRelease(data) {
  return request({
    url:'/admin/withdrawal/release/'+data,
    method:'put',
  })
}
//获取资产记录列表
export function getRecord(params) {
  return request({
    url:'/admin/transaction',
    method:'get',
    params:params
  })
}
//获取银行卡列表
export function getBankCard(params) {
  return request({
    url:'/admin/bindBankCard',
    method:'get',
    params:params
  })
}
export function updateBankCard(params) {
  return request({
    url:'/admin/bindBankCard/update',
    method:'put',
    data:params
  })
}
//删除银行卡
export function deleteBankCard(data) {
  return request({
    url:'/admin/bindBankCard/delete/' + data,
    method:'delete',
  })
}
//入金管理
export function getDeposit(params) {
  return request({
    url:'/admin/deposit/list',
    method:'get',
    params:params
  })
}
//入金审核通过
export function passReviewV1(data) {
  return request({
    url:'/admin/deposit/pass?withdrawalId='+data.withdrawalId+'&amount='+data.amount+"&gamount="+data.gamount,
    method:'get',
  })
}
//入金getBankCard审核不通过
export function failReviewV1(data) {
  return request({
    url:'/admin/deposit/fail',
    // url:'/admin/deposit/fail?withdrawalId='+data.withdrawalId+'&reasonReview='+data.reasonReview,
    method:'put',
    data:data
  })
}
export function getAdminBankCard(data) {
  return request({
    url:'/admin/bank/list',
    method:'post',
    data:data
  })
}

export function deleteAdminBankCard(data) {
  return request({
    url:'/admin/bank/remove',
    method:'get',
    params: data
  })
}

export function addAndEditAdminBankCard(data) {
  return request({
    url:'/admin/bank/saveAndUpdate',
    method:'post',
    data:data
  })
}

export function withdrawal(data) {
  return request({
    url:'/admin/withdrawal',
    method:'post',
    data:data
  })
}

export function listMyCards(data) {
  return request({
    url:'/admin/withdrawal/listMyCards',
    method:'get',
    params: data
  })
}
export function updateStatus(data) {
  return request({
    url:'/admin/bank/updateStatus',
    method:'get',
    params: data
  })
}

//检查最近1分钟内是否有新入金
export function checkRecentDeposit() {
  return request({
    url:'/admin/deposit/check-recent-deposit',
    method:'get'
  })
}

//检查最近1分钟内是否有会员注册记录
export function checkRecentRegistration() {
  return request({
    url:'/admin/member/check-recent-registration',
    method:'get'
  })
}

//检查最近1分钟内是否有出金记录
export function checkRecentWithdrawal() {
  return request({
    url:'/admin/withdrawal/check-recent-withdrawal',
    method:'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/assets.js